<template>
<div id="catalogo_mt" >
    <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
    components: {
        "v-power-catalogo": powerCatalogo
    },
    mounted() {},

    data: () => ({
        fab: false,
        parametros: {
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 17,
            title: "CLAVES DE PAISES",
            columns: ["clave_f3", "clave_m3", "nombre", "actions"],
            options: {
                filterable: ["clave_f3", "clave_m3", "nombre"],
                sortable: ["clave_f3", "clave_m3", "nombre"],

                headings: {
                    clave_f3: "Clave F3",
                    clave_m3: "CLAVE PAÍS Anexo 22",
                    nombre: "Descripción",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                Clave_f3: "clave_f3",
                Clave_m3: "clave_m3",
                Nombre: "nombre"
            },
            encabezadoLayout: {
                clave_f3: "clave_f3",
                clave_m3: "clave_m3",
                nombre: "nombre"
            },
            camposLayout: [{
                clave_f3: "[Clave F3 del País]",
                clave_m3: "[Clave M3 del País]",
                nombre: "[Nombre del País]"
            }],
            model: {
                id: 0,
                clave_f3: "",
                clave_m3: "",
                nombre: ""
            },
            form: {
                clave_f3: {
                    requiered: true,
                    label: "Clave_f3",
                    value: "",
                    maxlen: 20
                },
                clave_m3: {
                    requiered: true,
                    label: "Clave_m3",
                    value: "",
                    maxlen: 20
                },
                nombre: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 200
                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        }
    })
};
</script>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>